import { render, staticRenderFns } from "./HistryIndex.vue?vue&type=template&id=0e4ba6bf&scoped=true&"
import script from "./HistryIndex.vue?vue&type=script&lang=js&"
export * from "./HistryIndex.vue?vue&type=script&lang=js&"
import style0 from "./HistryIndex.vue?vue&type=style&index=0&id=0e4ba6bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4ba6bf",
  null
  
)

export default component.exports